import { HorizontalSafeAreaContainer } from '../../../components';
import { JoinOrSignInScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <HorizontalSafeAreaContainer>
      <JoinOrSignInScreen />
    </HorizontalSafeAreaContainer>
  );
}
